import { combineReducers, createStore } from "redux";
import { composeWithDevTools } from "@redux-devtools/extension";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import appStateReducer from "./data/reducer/appState.reducer";
import authReducer from "./data/reducer/auth.reducer";
import patientDetailsReducer from "./data/reducer/patientDetails.reducer";
import visitsReducer from "./data/reducer/visits.reducer";
import visitsDetailsReducer from "./data/reducer/visitsDetails.reducer";
import componentReducer from "./data/reducer/component.reducer";
import pageLoaderReducer from "./data/reducer/pageLoader.reducer";
import languageReducer from "./data/reducer/language.reducer";
import bloodSugarRecordReducer from "./data/reducer/bloodSugarRecord.reducer";
import hypoglycemiaReducer from "./data/reducer/hypoglycemia.reducer";

const rootReducer = combineReducers({
  appState: appStateReducer,
  auth: authReducer,
  component: componentReducer,
  PatientDetails: patientDetailsReducer,
  visits: visitsReducer,
  useVisitDetails: visitsDetailsReducer,
  pageLoader: pageLoaderReducer,
  language: languageReducer,
  BloodSugarRecord: bloodSugarRecordReducer,
  Hypoglycemia: hypoglycemiaReducer,
});

const persistConfig = {
  key: "root",
  storage,
  whitelist: [
    "appState",
    "auth",
    "visits",
    "language",
    "component",
    "useVisitDetails",
    "Hypoglycemia",
    "BloodSugarRecord",
  ],
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = createStore(persistedReducer, composeWithDevTools());

export const persistor = persistStore(store);

export default store;
